// extracted by mini-css-extract-plugin
module.exports = {"wrap":"legend_wrap_1bLua","fanhui":"legend_fanhui_2C3zf","fullScreen":"legend_fullScreen_2RKtN"};